import { useState } from 'react'
import { mapPosterUrl } from './shotManifest'

type PosterThumbProps = {
  /** Shot id → `/scenario-posters/<id>.png` */
  shotId: string
  /** Optional wizard art-* tone for the error-only CSS sketch. */
  artClass?: string
  className?: string
  caption?: string
}

/**
 * Committed poster PNG. Neutral panel shows until the image paints — never the
 * old CSS sketch (that only appears if the PNG fails to load).
 */
export function PosterThumb({ shotId, artClass, className, caption }: PosterThumbProps) {
  const [failed, setFailed] = useState(false)
  const art = artClass ? ` art-${artClass}` : ''
  const extra = className ? ` ${className}` : ''

  return (
    <div className={`sc-wizard-preview${art}${extra}`} aria-hidden="true">
      {failed ? (
        <div className="sc-wizard-preview-map">
          <span className="sc-wizard-preview-road a" />
          <span className="sc-wizard-preview-road b" />
          <span className="sc-wizard-preview-pin p1" />
          <span className="sc-wizard-preview-pin p2" />
          <span className="sc-wizard-preview-zone" />
          {artClass === 'walkthrough' || artClass === 'exercise' ? (
            <span className="sc-wizard-preview-rail" />
          ) : null}
        </div>
      ) : (
        <img
          className="sc-wizard-preview-photo"
          src={mapPosterUrl(shotId)}
          alt=""
          draggable={false}
          onError={() => setFailed(true)}
        />
      )}
      {caption ? <div className="sc-wizard-preview-caption">{caption}</div> : null}
    </div>
  )
}
